import { render } from "./ApplicationLogo.vue?vue&type=template&id=0c039b6c"
const script = {}

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__